// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2bGGR","description":"PatientConsentPreview_description__2s5W1"};